import React from 'react';
import { InfoCircleOutlined, BarsOutlined } from '@ant-design/icons';
import {
    Menu,
    Dropdown,
} from 'antd';
import 'antd/dist/antd.css';
import './LZHXComponentHomePage.css'
import LZHXOrderList from '../orderSearchPage/LZHXOrderList'
import LZHXProductSearchPage from '../productSearchPage/LZHXProductSearchPage'

class LZHXComponentHomePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            current: "orderSearch"
        };

        this.handleClick.bind(this);
        this.menu = (
            <Menu>
              <Menu.Item key="productSearch" icon={<InfoCircleOutlined />} onClick={this.handleClick}>
                <a>
                  商品搜索页
                </a>
              </Menu.Item>
              <Menu.Item key="orderSearch" icon={<InfoCircleOutlined />} onClick={this.handleClick}>
                <a>
                  订单搜索页
                </a>
              </Menu.Item>
            </Menu>
          );
    }

    componentDidMount() {

    }

    //切换页面
    handleClick = e => {
        this.setState({ current: e.key });
    };

    render() {

        return (
            <>
                <div id="menu">
                    <Dropdown overlay={this.menu} trigger={"click"}>
                        <a className="ant-dropdown-link">
                            <BarsOutlined />  切换页面
                        </a>
                    </Dropdown>
                </div>
                <br/>
                <br/>
                {this.state.current === "orderSearch" ? <LZHXOrderList/> : <LZHXProductSearchPage />}
            </>
        );
    }
}

export default LZHXComponentHomePage;